"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAssociatedObject;

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var NO_ASSOCIATION = (0, _immutable.Map)({
  objectType: undefined,
  associationId: undefined
});

function getAssociatedObject(task) {
  var objectType;
  var associationId;

  if (!task) {
    return NO_ASSOCIATION;
  }

  var associations = task.get('associations');
  var dealId = associations.get('dealIds').first();
  var contactId = associations.get('contactIds').first();
  var companyId = associations.get('companyIds').first();
  var ticketId = associations.get('ticketIds').first();

  if (!dealId && !contactId && !companyId && !ticketId) {
    return (0, _immutable.Map)({
      objectType: undefined,
      associationId: undefined
    });
  }

  if (contactId) {
    objectType = _ObjectTypes.CONTACT;
    associationId = contactId;
  } else if (companyId) {
    objectType = _ObjectTypes.COMPANY;
    associationId = companyId;
  } else if (dealId) {
    objectType = _ObjectTypes.DEAL;
    associationId = dealId;
  } else if (ticketId) {
    objectType = _ObjectTypes.TICKET;
    associationId = ticketId;
  }

  return (0, _immutable.Map)({
    objectType: objectType,
    associationId: associationId
  });
}

module.exports = exports.default;